import React, { useEffect } from "react";
import { Flex, Spin, Typography } from "@murm/ant";
import { useAuth } from "../../hooks/useAuth";
import styles from "./FullScreen.module.css";

const { Text } = Typography;

const Logout = () => {
  const { logout } = useAuth();

  useEffect(() => {
    const doLogout = async () => {
      await logout({ logoutParams: { returnTo: window.location.origin } });
    };

    doLogout();
  }, [logout]);

  return (
    <Flex
      align="center"
      justify="center"
      className={styles.fullScreen}
      vertical
      gap="middle"
    >
      <Spin size="large" />
      <Text type="secondary">Logging out…</Text>
    </Flex>
  );
};

export default Logout;
